 /*-----quick view box section css start------*/
 document.addEventListener('click', function (e) {
    const btn = e.target.closest('.rug-quick-btn');
    if (!btn) return;

    e.preventDefault();

    const modal = document.getElementById('rugQuickModal');

    document.getElementById('rug-qv-title').innerText = btn.dataset.title || '';
    document.getElementById('rug-qv-price').innerText = btn.dataset.price ||'';
    document.getElementById('rug-qv-size').innerText =
      btn.dataset.size ? 'Available Sizes: ' + btn.dataset.size : '';
    document.getElementById('rug-qv-desc').innerText = btn.dataset.desc || '';
    document.getElementById('rug-qv-link').href = btn.dataset.url || '#';

    modal.classList.add('active');
  });

  document.addEventListener('click', function (e) {
    if (
      e.target.classList.contains('rug-modal-close') ||
      e.target.id === 'rugQuickModal'
    ) {
      document.getElementById('rugQuickModal').classList.remove('active');
    }
  });
/*-----quick view box section css end------*/

/*-----search bar js start------*/
// document.addEventListener('click', function (e) {
//   const searchBtn = e.target.closest('.custom_header_search .search__button');
//   if (!searchBtn) return;

//   const wrapper = searchBtn.closest('.custom_header_search');
//   const input = wrapper.querySelector('.search__input');

//   // ❌ preventDefault only when closed
//   if (!wrapper.classList.contains('search-open')) {
//     e.preventDefault(); // first click open karega
//     wrapper.classList.add('search-open');

//     if (input) input.focus();
//   }
// });
// // Optional: click outside to close
// document.addEventListener('click', function (e) {
//   const wrapper = document.querySelector('.custom_header_search');
//   if (!wrapper) return;

//   if (!wrapper.contains(e.target)) {
//     wrapper.classList.remove('search-open');
//   }
// });

/*-----search bar js end------*/

/*-----Inventory search bar js start------*/
/*----- Inventory Search + Searchanise Integration -----*/

document.addEventListener("DOMContentLoaded", () => {

  const els = {
    widthMin: document.getElementById("widthMin"),
    widthMax: document.getElementById("widthMax"),
    lengthMin: document.getElementById("lengthMin"),
    lengthMax: document.getElementById("lengthMax"),

    widthMinVal: document.getElementById("widthMinVal"),
    widthMaxVal: document.getElementById("widthMaxVal"),

    lengthMinVal: document.getElementById("lengthMinVal"),
    lengthMaxVal: document.getElementById("lengthMaxVal"),

    viewBtn: document.getElementById("viewResultsBtn"),

    liveCount: document.getElementById("liveResultCount")
  };

  if (!els.widthMin) return;

  /* =========================================
     SEARCHANISE FILTER PARAMS
  ========================================= */

  const WIDTH_FILTER =
    "rb_filter_metafield_6572af49364a0f6c6390ca4266d0c496";

  const LENGTH_FILTER =
    "rb_filter_metafield_9360553f2388c37266d7da2c5f1cbda7";

  /* =========================================
     UNIT CONVERSION
  ========================================= */

  const FT_TO_M = 0.3048;
  let currentUnit = "feet";

  const unitRadios = document.querySelectorAll('input[name="unit"]');

  const widthLabel = document.getElementById("desktopWidthLabel");
  const lengthLabel = document.getElementById("desktopLengthLabel");

  const selectedWidthLive =
    document.getElementById("selectedWidthLive");

  const selectedLengthLive =
    document.getElementById("selectedLengthLive");

  /* =========================================
     CONVERT VALUE
  ========================================= */

  function convertValue(value) {

    const num = Number(value);

    return currentUnit === "meter"
      ? (num * FT_TO_M).toFixed(2)
      : num;

  }

  /* =========================================
     RANGE MASK
  ========================================= */

  function updateRangeMask(minEl, maxEl) {

    const min = Number(minEl.value);
    const max = Number(maxEl.value);

    const minLimit = Number(minEl.min);
    const maxLimit = Number(minEl.max);

    const step = Number(minEl.step || 1);

    const totalSteps = (maxLimit - minLimit) / step;

    const startStep = (min - minLimit) / step;
    const endStep = (max - minLimit) / step;

    const minPercent =
      (startStep / totalSteps) * 100;

    const maxPercent =
      (endStep / totalSteps) * 100;

    const wrapper = minEl.closest(".range-wrapper");

    if (!wrapper) return;

    wrapper.style.setProperty("--min", `${minPercent}%`);
    wrapper.style.setProperty("--max", `${maxPercent}%`);
  }

  /* =========================================
     CLAMP RANGE
  ========================================= */

  function clampRanges(minEl, maxEl) {

    let minVal = Number(minEl.value);
    let maxVal = Number(maxEl.value);

    if (minVal > maxVal) {
      minEl.value = maxVal;
    }
  }

  /* =========================================
     THUMB POSITION
  ========================================= */

  function setThumbPosition(input, label) {

    if (!input || !label) return;

    const min = input.min;
    const max = input.max;
    const val = input.value;

    const percent =
      ((val - min) / (max - min)) * 100;

    label.style.left = percent + "%";
  }

  /* =========================================
     LIVE WIDTH
  ========================================= */

  function updateSelectedWidthLive() {

    if (!selectedWidthLive) return;

    const wMin = els.widthMin.value;
    const wMax = els.widthMax.value;

    if (currentUnit === "meter") {

      selectedWidthLive.innerHTML =
        `${convertValue(wMin)}m x ${convertValue(wMax)}m`;

    } else {

      selectedWidthLive.innerHTML =
        `${wMin}ft x ${wMax}ft`;

    }
  }

  /* =========================================
     LIVE LENGTH
  ========================================= */

  function updateSelectedLengthLive() {

    if (!selectedLengthLive) return;

    const lMin = els.lengthMin.value;
    const lMax = els.lengthMax.value;

    if (currentUnit === "meter") {

      selectedLengthLive.innerHTML =
        `${convertValue(lMin)}m x ${convertValue(lMax)}m`;

    } else {

      selectedLengthLive.innerHTML =
        `${lMin}ft x ${lMax}ft`;

    }
  }

  /* =========================================
     UPDATE LABELS
  ========================================= */

  function updateLabels() {

    if (els.widthMinVal) {
      els.widthMinVal.textContent =
        convertValue(els.widthMin.value);
    }

    if (els.widthMaxVal) {
      els.widthMaxVal.textContent =
        convertValue(els.widthMax.value);
    }

    if (els.lengthMinVal) {
      els.lengthMinVal.textContent =
        convertValue(els.lengthMin.value);
    }

    if (els.lengthMaxVal) {
      els.lengthMaxVal.textContent =
        convertValue(els.lengthMax.value);
    }

    if (widthLabel) {

      widthLabel.textContent =
        currentUnit === "meter"
          ? "Width (m)"
          : "Width (ft)";
    }

    if (lengthLabel) {

      lengthLabel.textContent =
        currentUnit === "meter"
          ? "Length (m)"
          : "Length (ft)";
    }



    updateRangeMask(els.widthMin, els.widthMax);

    updateRangeMask(els.lengthMin, els.lengthMax);

    updateSelectedWidthLive();

    updateSelectedLengthLive();

    setThumbPosition(
      els.widthMin,
      els.widthMinVal
    );

    setThumbPosition(
      els.widthMax,
      els.widthMaxVal
    );

    setThumbPosition(
      els.lengthMin,
      els.lengthMinVal
    );

    setThumbPosition(
      els.lengthMax,
      els.lengthMaxVal
    );
  }

  function updateLiveResultCount() {

    const snizeCountEl = document.querySelector(
      ".snize-main-panel-collection-results-found b"
    );

    if (!snizeCountEl || !els.liveCount) return;

    const total =
      snizeCountEl.textContent.trim();

    els.liveCount.textContent = total;
  }

  /* =========================================
     SEARCHANISE FILTER UPDATE
  ========================================= */

  function updateSearchaniseFilters(reloadPage = false) {

    const widthMin = els.widthMin.value;
    const widthMax = els.widthMax.value;

    const lengthMin = els.lengthMin.value;
    const lengthMax = els.lengthMax.value;

    const widthValue =
      `${widthMin},${widthMax}`;

    const lengthValue =
      `${lengthMin},${lengthMax}`;

    const params =
      new URLSearchParams(window.location.search);

    params.set(WIDTH_FILTER, widthValue);

    params.set(LENGTH_FILTER, lengthValue);

    const finalUrl =
      `/collections/search-results?${params.toString()}`;

    // Update browser URL
    window.history.replaceState({}, '', finalUrl);

    // Button click = real redirect
    if (reloadPage) {

      window.location.href = finalUrl;

      return;
    }

    // AJAX Searchanise refresh
    if (window.Searchanise) {

      window.Searchanise.SetResultsParams({
        [WIDTH_FILTER]: widthValue,
        [LENGTH_FILTER]: lengthValue
      });

      // Trigger refresh
      window.Searchanise.Start();

      setTimeout(() => {

        updateLiveResultCount();

      }, 1200);
    }
  }

  /* =========================================
     RANGE EVENTS
  ========================================= */

  [els.widthMin, els.widthMax].forEach(el => {

    el?.addEventListener("input", () => {

      clampRanges(
        els.widthMin,
        els.widthMax
      );

      updateLabels();
      updateSearchaniseFilters(false);
    });

  });

  [els.lengthMin, els.lengthMax].forEach(el => {

    el?.addEventListener("input", () => {

      clampRanges(
        els.lengthMin,
        els.lengthMax
      );

      updateLabels();
      updateSearchaniseFilters(false);
    });

  });

  /* =========================================
     UNIT CHANGE
  ========================================= */

  unitRadios.forEach(radio => {

    radio.addEventListener("change", function () {

      currentUnit = this.value;

      updateLabels();


    });

  });

  /* =========================================
     BUTTON CLICK
  ========================================= */

  els.viewBtn?.addEventListener("click", () => {

    updateSearchaniseFilters(true);

  });

  /* =========================================
     INIT
  ========================================= */

  updateLabels();

/* =========================================
   LIVE RESULT COUNT
========================================= */

setTimeout(() => {

  updateLiveResultCount();

}, 2000);

});


/*----- MOBILE Inventory Search + Searchanise Integration -----*/

document.addEventListener("DOMContentLoaded", () => {

  const els = {

    widthMin: document.getElementById("mobileWidthMin"),
    widthMax: document.getElementById("mobileWidthMax"),

    lengthMin: document.getElementById("mobileLengthMin"),
    lengthMax: document.getElementById("mobileLengthMax"),

    widthMinVal: document.getElementById("mobileWidthMinVal"),
    widthMaxVal: document.getElementById("mobileWidthMaxVal"),

    lengthMinVal: document.getElementById("mobileLengthMinVal"),
    lengthMaxVal: document.getElementById("mobileLengthMaxVal"),

    viewBtn: document.getElementById("mobileViewResultsBtn"),

    liveCount: document.getElementById("mobileLiveResultCount")
  };

  if (!els.widthMin) return;

  /* =========================================
     SEARCHANISE FILTER PARAMS
  ========================================= */

  const WIDTH_FILTER =
    "rb_filter_metafield_6572af49364a0f6c6390ca4266d0c496";

  const LENGTH_FILTER =
    "rb_filter_metafield_9360553f2388c37266d7da2c5f1cbda7";

  /* =========================================
     UNIT CONVERSION
  ========================================= */

  const FT_TO_M = 0.3048;

  let currentUnit = "feet";

  const unitRadios =
    document.querySelectorAll(
      '.inventory-search-search input[name="unit"]'
    );

  const widthLabel =
    document.querySelector(
      ".inventory-search-search #widthLabel"
    );

  const lengthLabel =
    document.querySelector(
      ".inventory-search-search #lengthLabel"
    );

  const selectedWidthLive =
    document.getElementById("mobileselectedWidthLive");

  const selectedLengthLive =
    document.getElementById("mobileselectedLengthLive");

  /* =========================================
     CONVERT VALUE
  ========================================= */

  function convertValue(value) {

    const num = Number(value);

    return currentUnit === "meter"
      ? (num * FT_TO_M).toFixed(2)
      : num;
  }

  /* =========================================
     RANGE MASK
  ========================================= */

  function updateRangeMask(minEl, maxEl) {

    const min = Number(minEl.value);
    const max = Number(maxEl.value);

    const minLimit = Number(minEl.min);
    const maxLimit = Number(maxEl.max);

    const step = Number(minEl.step || 1);

    const totalSteps = (maxLimit - minLimit) / step;

    const startStep = (min - minLimit) / step;
    const endStep = (max - minLimit) / step;

    const minPercent =
      (startStep / totalSteps) * 100;

    const maxPercent =
      (endStep / totalSteps) * 100;

    const wrapper = minEl.closest(".range-wrapper");

    if (!wrapper) return;

    wrapper.style.setProperty("--min", `${minPercent}%`);
    wrapper.style.setProperty("--max", `${maxPercent}%`);
  }

  /* =========================================
     CLAMP RANGE
  ========================================= */

  function clampRanges(minEl, maxEl) {

    let minVal = Number(minEl.value);
    let maxVal = Number(maxEl.value);

    if (minVal > maxVal) {

      minEl.value = maxVal;
    }
  }

  /* =========================================
     THUMB POSITION
  ========================================= */

  function setThumbPosition(input, label) {

    if (!input || !label) return;

    const min = input.min;
    const max = input.max;
    const val = input.value;

    const percent =
      ((val - min) / (max - min)) * 100;

    label.style.left = percent + "%";
  }

  /* =========================================
     LIVE WIDTH
  ========================================= */

  function updateSelectedWidthLive() {

    if (!selectedWidthLive) return;

    const wMin = els.widthMin.value;
    const wMax = els.widthMax.value;

    if (currentUnit === "meter") {

      selectedWidthLive.innerHTML =
        `${convertValue(wMin)}m x ${convertValue(wMax)}m`;

    } else {

      selectedWidthLive.innerHTML =
        `${wMin}ft x ${wMax}ft`;
    }
  }

  /* =========================================
     LIVE LENGTH
  ========================================= */

  function updateSelectedLengthLive() {

    if (!selectedLengthLive) return;

    const lMin = els.lengthMin.value;
    const lMax = els.lengthMax.value;

    if (currentUnit === "meter") {

      selectedLengthLive.innerHTML =
        `${convertValue(lMin)}m x ${convertValue(lMax)}m`;

    } else {

      selectedLengthLive.innerHTML =
        `${lMin}ft x ${lMax}ft`;
    }
  }

  /* =========================================
     UPDATE LABELS
  ========================================= */

  function updateLabels() {

    els.widthMinVal.textContent =
      convertValue(els.widthMin.value);

    els.widthMaxVal.textContent =
      convertValue(els.widthMax.value);

    els.lengthMinVal.textContent =
      convertValue(els.lengthMin.value);

    els.lengthMaxVal.textContent =
      convertValue(els.lengthMax.value);

    if (widthLabel) {

      widthLabel.innerHTML =
        currentUnit === "meter"
          ? "Width (m)"
          : "Width (ft)";
    }

    if (lengthLabel) {

      lengthLabel.innerHTML =
        currentUnit === "meter"
          ? "Length (m)"
          : "Length (ft)";
    }

    updateRangeMask(
      els.widthMin,
      els.widthMax
    );

    updateRangeMask(
      els.lengthMin,
      els.lengthMax
    );

    updateSelectedWidthLive();

    updateSelectedLengthLive();

    setThumbPosition(
      els.widthMin,
      els.widthMinVal
    );

    setThumbPosition(
      els.widthMax,
      els.widthMaxVal
    );

    setThumbPosition(
      els.lengthMin,
      els.lengthMinVal
    );

    setThumbPosition(
      els.lengthMax,
      els.lengthMaxVal
    );
  }

  /* =========================================
     LIVE COUNT
  ========================================= */

  function updateLiveResultCount() {

    const snizeCountEl = document.querySelector(
      ".snize-main-panel-collection-results-found b"
    );

    if (!snizeCountEl || !els.liveCount) return;

    els.liveCount.textContent =
      snizeCountEl.textContent.trim();
  }

  /* =========================================
     SEARCHANISE UPDATE
  ========================================= */

  function updateSearchaniseFilters(reloadPage = false) {

    const widthValue =
      `${els.widthMin.value},${els.widthMax.value}`;

    const lengthValue =
      `${els.lengthMin.value},${els.lengthMax.value}`;

    const params =
      new URLSearchParams(window.location.search);

    params.set(WIDTH_FILTER, widthValue);

    params.set(LENGTH_FILTER, lengthValue);

    const finalUrl =
      `/collections/search-results?${params.toString()}`;

    window.history.replaceState({}, '', finalUrl);

    if (reloadPage) {

      window.location.href = finalUrl;

      return;
    }

    if (window.Searchanise) {

      window.Searchanise.SetResultsParams({
        [WIDTH_FILTER]: widthValue,
        [LENGTH_FILTER]: lengthValue
      });

      window.Searchanise.Start();

      setTimeout(() => {

        updateLiveResultCount();

      }, 1200);
    }
  }

  /* =========================================
     RANGE EVENTS
  ========================================= */

  [els.widthMin, els.widthMax].forEach(el => {

    el?.addEventListener("input", () => {

      clampRanges(
        els.widthMin,
        els.widthMax
      );

      updateLabels();

      updateSearchaniseFilters(false);
    });
  });

  [els.lengthMin, els.lengthMax].forEach(el => {

    el?.addEventListener("input", () => {

      clampRanges(
        els.lengthMin,
        els.lengthMax
      );

      updateLabels();

      updateSearchaniseFilters(false);
    });
  });

  /* =========================================
     UNIT CHANGE
  ========================================= */

  unitRadios.forEach(radio => {

    radio.addEventListener("change", function () {

      currentUnit = this.value;

      updateLabels();
    });
  });

  /* =========================================
     BUTTON CLICK
  ========================================= */

  els.viewBtn?.addEventListener("click", () => {

    updateSearchaniseFilters(true);
  });

  /* =========================================
     INIT
  ========================================= */

  updateLabels();

  setTimeout(() => {

    updateLiveResultCount();

  }, 2000);

});

/*-----Inventory search bar for mobile js end------*/

// collection in Inventory search start
document.addEventListener("click", function (e) {
  const clickedToggle = e.target.closest(".collection_inventory_search-metafield");
  const allItems = document.querySelectorAll(".collection-item-metafield");


  if (clickedToggle) {
    e.preventDefault();
    e.stopPropagation();

    const parentItem = clickedToggle.closest(".collection-item-metafield");
    const isOpen = parentItem.classList.contains("active");


    allItems.forEach(item => item.classList.remove("active"));

    // toggle current
    if (!isOpen) {
      parentItem.classList.add("active");
    }

    return;
  }


  if (e.target.closest(".dropdown-collections")) {
    return;
  }

  allItems.forEach(item => item.classList.remove("active"));
});
// collection in Inventory search end



// decription read more 

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".read-more-btn");
  const shortDesc = document.querySelector(".desc-short");
  const fullDesc = document.querySelector(".desc-full");

  if (btn) {
    btn.addEventListener("click", function () {
      if (fullDesc.style.display === "none") {
        fullDesc.style.display = "block";
        shortDesc.style.display = "none";
        btn.innerText = "Read Less";
      } else {
        fullDesc.style.display = "none";
        shortDesc.style.display = "block";
        btn.innerText = "Read More";
      }
    });
  }
});


// for img on the product page 

document.addEventListener("DOMContentLoaded", function() {

  document.querySelectorAll('.thumbnail-list__item button').forEach(function(button) {
    
    button.addEventListener("click", function(e) {
      e.preventDefault();

      const targetId = this.closest('.thumbnail-list__item').getAttribute("data-target");
      const targetSlide = document.querySelector('[data-media-id="' + targetId + '"]');

      if (targetSlide) {
        targetSlide.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }

    });

  });

});



// custom  sort filter start April 18, 2026
let currentSort = localStorage.getItem("rugSortOrder") || "asc";
let isUserChanged = false;
let isSorting = false;
let firstSortDone = false;

// ---------------- PAGE GRID DETECT ----------------
function getGrid() {
  // Search Page
  if (document.body.classList.contains("search")) {
    return document.querySelector("#product-grid ul.product-grid");
  }

  // Collection Page
  if (document.body.classList.contains("collection")) {
    return document.querySelector(".collection #product-grid");
  }

  return null;
}

// ---------------- LOADER ----------------
function showSortLoader() {
  let loader = document.getElementById("sort-loader");

  if (!loader) {
    loader = document.createElement("div");
    loader.id = "sort-loader";
    loader.innerHTML = "Sorting products...";
    loader.style.cssText = `
      position: fixed;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255,255,255,0.75);
      z-index: 99999;
      font-size: 16px;
      font-weight: 500;
    `;
    document.body.appendChild(loader);
  }

  loader.style.display = "flex";
}

function hideSortLoader() {
  const loader = document.getElementById("sort-loader");
  if (loader) loader.style.display = "none";
}

// ---------------- SORT FUNCTION ----------------
function sortProducts(order, silent = false) {
  const grid = getGrid();
  if (!grid || !order || isSorting) return;

  const cards = Array.from(grid.querySelectorAll(".grid__item"));
  if (!cards.length) return;

  isSorting = true;

  cards.sort((a, b) => {
    const aWidth = parseFloat(a.dataset.rugWidth) || 0;
    const bWidth = parseFloat(b.dataset.rugWidth) || 0;

    return order === "asc"
      ? aWidth - bWidth
      : bWidth - aWidth;
  });

  const frag = document.createDocumentFragment();
  cards.forEach(card => frag.appendChild(card));
  grid.appendChild(frag);

  setTimeout(() => {
    isSorting = false;
  }, 0);

  if (!silent) {
    const select = document.getElementById("width-sort");
    if (select) select.value = order;
  }
}

// ---------------- USER CHANGE ----------------
document.addEventListener("change", (e) => {
  if (e.target?.id === "width-sort") {
    currentSort = e.target.value;
    isUserChanged = true;

    localStorage.setItem("rugSortOrder", currentSort);

    if (!firstSortDone) {
      showSortLoader();

      requestAnimationFrame(() => {
        sortProducts(currentSort);
        hideSortLoader();
        firstSortDone = true;
      });
    } else {
      sortProducts(currentSort);
    }
  }
});

// ---------------- OBSERVER ----------------
const observer = new MutationObserver(() => {
  if (isSorting) return;
  if (!isUserChanged) return;

  requestAnimationFrame(() => {
    sortProducts(currentSort, true);
  });
});

// ---------------- INIT ----------------
document.addEventListener("DOMContentLoaded", () => {
  const gridContainer = document.querySelector("#ProductGridContainer");
  const select = document.getElementById("width-sort");

  if (!gridContainer) return;

  observer.observe(gridContainer, {
    childList: true,
    subtree: true
  });

  if (select) {
    select.value = currentSort;

    requestAnimationFrame(() => {
      sortProducts(currentSort, true);
      isUserChanged = true;
      firstSortDone = true;
    });
  }
});
// custom  sort filter end April 18, 2026


// inventory serch menu open close js start
document.addEventListener("DOMContentLoaded", function () {
  const menu = document.querySelector("ul.mega-menu.mega-menu--shop");
  const content = document.querySelector(".mega-menu__content_custom");

  if (!menu) return;

  // Toggle menu only when clicking the top menu area
  menu.addEventListener("click", function (e) {
    // Ignore clicks inside dropdown content
    if (e.target.closest(".mega-menu__content_custom")) return;

    e.preventDefault();
    e.stopPropagation();
    menu.classList.toggle("active");
  });

  // Close menu when clicking outside
  document.addEventListener("click", function (e) {
    if (
      !menu.contains(e.target) &&
      !(content && content.contains(e.target))
    ) {
      menu.classList.remove("active");
    }
  });
});
// inventory serch menu open close js end

// contact for piricing April 28, 2026
// document.addEventListener("DOMContentLoaded", function () {
//   const params = new URLSearchParams(window.location.search);

//   const rugName = params.get("rug_name");
//   const rugNumber = params.get("rug_number");

//   const rugNameField = document.getElementById("ContactForm-rug-name");
//   const rugNumberField = document.getElementById("ContactForm-rug-number");

//   if (rugName && rugNameField) {
//     rugNameField.value = rugName;
//   }

//   if (rugNumber && rugNumberField) {
//     rugNumberField.value = rugNumber;
//   }
// });
// contact for piricing April 28, 2026


  document.addEventListener("DOMContentLoaded", function () {
    const params = new URLSearchParams(window.location.search);
    const rug = params.get("rug_url");

    if (rug) {
      document.getElementById("ContactForm-rug-link").value =
        window.location.origin + rug;
    }
  });



  // for Color Inventory filter - 22 July, 2026

  document.querySelectorAll(".color-swatch").forEach(color => {

    color.addEventListener("click", function (e) {

        e.preventDefault();

        const colorName = this.dataset.color;

        const params = new URLSearchParams();

        params.set(
            "sort_by",
            "metafield_6572af49364a0f6c6390ca4266d0c496"
        );

        params.set("sort_order", "desc");
        params.set("page", "1");

        params.set(
            "rb_filter_metafield_0ae92a27727575049d0236f9962e3023",
            colorName
        );

        window.location.href = "/collections/all?" + params.toString();

    });

});

  // for Rug Size Inventory filter - 24 July, 2026